var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dplayer-wrap ghzs-player",on:{"contextmenu":function($event){$event.preventDefault();}}},[_c('div',{ref:"dplayer",staticClass:"dplayer"})])}
var staticRenderFns = []

export { render, staticRenderFns }